<template>
	<el-dialog class="reportDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				举报
			</div>
		</div>
		<div class="dislogConent">
			<el-form ref="reportRuleForm" hide-required-asterisk :model="reportRuleForm" :rules="reportRules">
				<el-form-item label="温馨提示：" prop="tip">
					<div class="tips">
						很遗憾，给您带来了不好的体验。您可将自己的举报提交3D鞋壳数字平台审核官！
					</div>
				</el-form-item>
				<el-form-item label="举报对象：" prop="user">
					<div class="avatarName">
						<img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar" />
						<img class="avatar" src="../assets/Personal/iconF.png" v-else />
						<div class="name">
							{{userInfo.nickname ? userInfo.nickname : ''}}
						</div>
					</div>
				</el-form-item>
				<el-form-item label="举报原因：" prop="title">
					<el-select v-model="reportRuleForm.title" class="inputBox" placeholder="请选择举报原因" clearable>
						<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name" />
					</el-select>
				</el-form-item>
				<el-form-item label="举报描述：" prop="content">
					<div class="reportContent">
						<el-input v-model="reportRuleForm.content" type="textarea" maxlength="200"
							placeholder="请输入举报描述" />
						<div class="textNum">
							<span>{{reportRuleForm.content ? reportRuleForm.content.length : 0}}</span>/200
						</div>
					</div>
				</el-form-item>
				<el-form-item label="证据截图：" prop="img">
					<div class="imgList">
						<div class="imgItem" v-for="(item,index) in imgList" :key="index">
							<img class="imgItemImg" :src="item" />
							<img class="delete" src="../assets/Feedback/delete.png" />
						</div>
						<div class="addImgBox" @click="uploadPhoto" v-if="imgList.length != 6">
							<img class="addImg" src="../assets/Feedback/addImg.png" />
							证据截图
						</div>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer">
			<div class="menuBox">
				<el-button class="submit" type="primary" size="medium"
					@click="submitForm('reportRuleForm')">提交</el-button>
			</div>
		</div>
		<el-upload ref="upload" name="image" action="https://ht.daiyuart.com/api.php/set/Other/upload_img"
			:show-file-list="false" :limit="6" multiple :on-success="handlePhotoSuccess">
		</el-upload>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			userInfo: {
				type: Object,
				default: () => {},
			},
		},
		data() {
			return {
				imgList: [],
				options: [{
					id: 1,
					name: '有血腥暴力或淫秽色情等违规内容',
				}, {
					id: 2,
					name: '发表不文明言论',
				}, {
					id: 3,
					name: '其他',
				}],
				reportRuleForm: {
					title: '',
					content: '',
				},
				reportRules: {
					title: [{
						required: true,
						message: '请选择举报原因',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
				this.reportRuleForm.title = ''
				this.reportRuleForm.content = ''
				this.imgList = []
			},
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response) {
				this.imgList.push(response.data)
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Hua/report_work', {
							title: this.reportRuleForm.title,
							content: this.reportRuleForm.content,
							img: this.imgList.join(','),
							mb_id: this.userInfo.id,
							type: 2,
						}).then(res => {
							this.handleClose()
							if (res.code == 1) {
								this.$emit('reportResult', {
									isSuc: true,
									title: '举报成功',
									desc: ''
								})
							} else {
								this.$emit('reportResult', {
									isSuc: false,
									title: '举报失败',
									desc: '您已举报过该画师'
								})
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.reportDialog {

		::v-deep .el-dialog {
			width: 7.40rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__body {
				padding: 0 .24rem;

				.tips {
					display: flex;
					align-items: center;
					font-weight: 500;
					font-size: .14rem;
					color: #312C28;
					line-height: .2rem;
				}

				.avatarName {
					display: flex;
					align-items: center;

					.avatar {
						margin-right: .08rem;
						width: .4rem;
						height: .4rem;
						border-radius: 50%;
						overflow: hidden;
						object-fit: cover;
					}

					.name {
						font-weight: 500;
						font-size: .14rem;
						color: #312C28;
					}
				}

				.reportContent {
					position: relative;

					.textNum {
						position: absolute;
						right: .12rem;
						bottom: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #999999;
						line-height: .2rem;

						span {
							color: #252525;
						}
					}
				}

				.imgList {
					display: flex;
					flex-wrap: wrap;

					.imgItem {
						margin-right: .16rem;
						display: flex;
						width: .86rem;
						height: .86rem;
						border-radius: .04rem;
						overflow: hidden;
						position: relative;

						.delete {
							position: absolute;
							top: .05rem;
							right: .05rem;
							width: .14rem;
							height: .14rem;
							cursor: pointer;
						}

						.imgItemImg {
							width: .86rem;
							height: .86rem;
							object-fit: cover;
						}
					}

					.addImgBox {
						width: .86rem;
						height: .86rem;
						border-radius: .04rem;
						background: #FFFFFF;
						border: 1px solid #EFD8B8;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						font-weight: 400;
						font-size: .12rem;
						color: #999999;
						cursor: pointer;
						line-height: .18rem;

						.addImg {
							margin-bottom: .08rem;
							width: .27rem;
							height: .23rem;
						}
					}
				}

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__content {
							line-height: unset;

							.el-textarea {
								&__inner {
									width: 6rem;
									height: 1.6rem;
									background: #FFFFFF;
									border-radius: .04rem;
									border: .01rem solid #EFD8B8;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
								}
							}

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	li {
		font-size: .14rem !important;
		margin-bottom: 0;
	}
</style>